import '../../datatables/custom_datatable';
import '../../datatables/redraw_dt';
import stripHtml from '../../strip_html';


export default function loadDefaultDatatable() {
  var dataTable = $('#route-section-datatable').DataTable({
    dom: 'rtp',
    scrollX: true,
    processing: true,
    serverSide: true,
    order: [[1, 'asc']],
    columns: [
      { data: 'actions' },
      { data: 'origin' },
      { data: 'modal_transport' },
      { data: 'destiny' },
      { data: 'modal_transport2' },
      { data: 'round_trip' },
      { data: 'toll_price' },
      { data: 'ref_value' },
      { data: 'transit_time' },
      { data: 'active' },
    ],
    buttons: [
      {
        extend: 'copyHtml5',
        text: 'Copiar',
        className: 'btn-sm',
        exportOptions: {
          columns: ':visible',
        },
      },
      {
        extend: 'excelHtml5',
        text: 'Excel',
        className: 'btn-sm',
        exportOptions: {
          columns: ':visible',
          format: {
            header: (data, _columnIdx) => {
              return data.toUpperCase();
            },
            body: (data, _columnIdx, node) => {
              return stripHtml(data).toUpperCase();
            },
          },
        },
      },
      // {
      //   className: 'btn-sm',
      //   text: 'Gerar PDF',
      //   action: function (e, dt, button, config) {
      //     let url = window.location.pathname;
      //     url = url + '_pdf';
      //     window.location.pathname = url;
      //   },
      // },
      {
        className: 'btn-sm',
        extend: 'colvis',
        text: 'Colunas',
      },
    ],
    ajax: {
      url: $('#route-section-datatable').data('source'),
      type: 'POST',
      data: function (d) {
        d.place1_city_id = $('#city-select-place1').val();
        d.place1_place_id = $('#place1_place_id').val();
        d.place2_city_id = $('#city-select-place2').val();
        d.place2_place_id = $('#place2_place_id').val();
        d.place3_city_id = $('#city-select-place3').val();
        d.place3_place_id = $('#place3_place_id').val();
        d.type = 'sections';
        d.active = $('#active').val();
      },
    },
  });
  $('.dt-filter').on('change', () => {
    dataTable.draw();
  });
}
